/**
 * Company Legal Information - Single Source of Truth
 * 
 * This file contains all official company data for legal pages,
 * footer, JSON-LD schema, and any other location requiring
 * verified corporate information.
 */

export const COMPANY = {
  // Legal Entity
  legalName: "VIS EXPERIENCE 24, S.L.",
  tradeName: "VisExperience",
  
  // Tax & Registration
  taxId: "B67343111", // CIF/NIF
  taxIdLabel: "CIF",
  
  // Registered Address
  address: {
    street: "AV ROMA núm. 35",
    floor: "Entresuelo, P.EN PTA.2",
    city: "Barcelona",
    postalCode: "08015",
    country: "España",
    countryCode: "ES",
  },
  
  // Commercial Registry (Registro Mercantil de Barcelona)
  registry: {
    location: "Barcelona",
    volume: "46771", // Tomo
    folio: "110",
    section: "8", // Sección
    sheet: "B-530351", // Hoja
    entry: "1", // Inscripción
  },
  
  // Corporate Details
  shareCapital: "3.000,00 €",
  incorporationDate: "2018-12-18", // Comienzo de operaciones
  registrationDate: "2019-02-21", // Fecha inscripción
  bormePublicationDate: "2019-03-01", // BORME
  
  // Contact (Government Partnerships Only)
  contact: {
    email: "partnerships@visexperience.com",
    type: "Government Partnerships",
  },
  
  // Website
  website: {
    url: "https://visexperience.com",
    domain: "visexperience.com",
  },
  
  // Operational Facts (Verified)
  operationalFacts: {
    yearsExperience: "10+",
    casesProcessed: "Hundreds of thousands",
    countriesPresent: "Dozens",
    languages: ["English", "Spanish", "French", "German", "Arabic", "Portuguese", "Chinese"],
  },
} as const;

/**
 * Formatted strings for common use cases
 */
export const COMPANY_FORMATTED = {
  // Full legal address (single line)
  fullAddress: `${COMPANY.address.street}, ${COMPANY.address.floor}, ${COMPANY.address.city} (${COMPANY.address.country})`,
  
  // Registry reference (Spanish format)
  registryReference: `Registro Mercantil de ${COMPANY.registry.location}, Tomo ${COMPANY.registry.volume}, Folio ${COMPANY.registry.folio}, Sección ${COMPANY.registry.section}, Hoja ${COMPANY.registry.sheet}, Inscripción ${COMPANY.registry.entry}`,
  
  // Registry reference (International format)
  registryReferenceEn: `Commercial Registry of ${COMPANY.registry.location}, Volume ${COMPANY.registry.volume}, Folio ${COMPANY.registry.folio}, Section ${COMPANY.registry.section}, Sheet ${COMPANY.registry.sheet}, Entry ${COMPANY.registry.entry}`,
  
  // Copyright line
  copyright: (year: number) => `© ${year} ${COMPANY.tradeName}. All rights reserved.`,
  
  // Legal entity line
  legalEntityLine: `${COMPANY.legalName} • ${COMPANY.taxIdLabel}: ${COMPANY.taxId}`,
} as const;

